import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DraggableList from 'react-draggable-list';
import { cloneDeep, remove } from 'lodash';
import getUuid from 'uuid/v4';
import { RadioGroup } from 'components';
import AddOptionButton from './components/AddOptionButton/AddOptionButton';
import RadioButtonBuilderOption from './components/RadioButtonBuilderOption/RadioButtonBuilderOption';
import styles from './RadioButtonBuilder.scss';

const getNewItem = () => {
    const uuid = getUuid();

    return {
        id: uuid,
        text: ''
    };
};

const RadioButtonBuilder = ({
    canAddOptions,
    defaultOptions,
    onChangeOptions,
    isDisabled
}) => {
    const [options, setOptions] = useState(defaultOptions);

    const handleChangeOptions = options => {
        setOptions(options);
        onChangeOptions(options);
    };

    const handleOptionTextChange = (id, newText) => {
        const newOptions = cloneDeep(options);
        const option = newOptions.find(option => option.id === id);
        option.text = newText;
        handleChangeOptions(newOptions);
    };

    const handleRemove = id => {
        const newOptions = cloneDeep(options);
        remove(newOptions, option => option.id === id);
        handleChangeOptions(newOptions);
    };

    const handleAdd = () => {
        const newOptions = cloneDeep(options);
        const newItem = getNewItem();
        newOptions.push(newItem);
        handleChangeOptions(newOptions);
    };

    return (
        <div className={styles.formControl}>
            <RadioGroup defaultValue>
                <DraggableList
                    list={options}
                    itemKey='id'
                    onMoveEnd={handleChangeOptions}
                    template={RadioButtonBuilderOption}
                    commonProps={{
                        isDisabled,
                        onChange: handleOptionTextChange,
                        onRemove: handleRemove
                    }}
                />

                <AddOptionButton
                    onClick={handleAdd}
                    isDisabled={isDisabled || !canAddOptions}
                />
            </RadioGroup>
        </div>
    );
};

RadioButtonBuilder.propTypes = {
    defaultOptions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string
    })),
    onChangeOptions: PropTypes.func,
    isDisabled: PropTypes.bool,
    canAddOptions: PropTypes.bool
};

RadioButtonBuilder.defaultProps = {
    defaultOptions: [
        { id: getUuid(), text: '' },
        { id: getUuid(), text: '' },
        { id: getUuid(), text: '' }
    ],
    onChangeOptions: () => {},
    isDisabled: false,
    canAddOptions: true
};

export default RadioButtonBuilder;
